<template>
    <a :href="`/impersonate/take/${coachAdmin.user.id}`">
        <figure>
            <svg-icon :icon="getFlag"></svg-icon>
        </figure>

        <span>{{ coachAdmin.user | fullname }} <template v-if="!isTestAdmin">({{ coachAdmin.user.country }})</template></span>
    </a>
</template>

<script>
export default {
    props: {
        coachAdmin: {
            type: Object,
            required: true
        }
    },

    computed: {
        isTestAdmin() {
            if(this.coachAdmin.user.email === 'testkoucadmin@vitad.io') {
                return true
            }

            return false
        },
        getFlag() {
            if(this.isTestAdmin) {
                return 'flags.usa_vi_big'
            } else {
                if(this.coachAdmin.user.country === 'CZ') {
                    return 'flags.cs_big'
                }

                if(this.coachAdmin.user.country === 'DE') {
                    return 'flags.de_big'
                }

                if(this.coachAdmin.user.country === 'SK') {
                    return 'flags.sk_big'
                }
            }
        }
    }
}
</script>
